export default "@media (max-width: 3000px) {\r\n  .body-content {\r\n    padding-top: 50px;\r\n    width: 100%;\r\n  }\r\n}\r\n";